

<!-- Message Container -->
<p-toast position="top-center" key="main-alert"></p-toast>
<p-blockUI [blocked]="(uiBlocked$ | async) ?? false">
    <i class="pi pi-spin pi-spinner" style="font-size: 8rem"></i>
</p-blockUI>


<!-- Sidebar for non-encounter workbench screens -->
<p-sidebar [(visible)]="rightSidebarVisible" (onHide)="hideSidebar()" position="right" [style]="{'width': 'max-content'}">
    <div class="flex border-2 border-dashed surface-border border-round surface-section h-full">
        <router-outlet name="sidebar"></router-outlet>
    </div>
</p-sidebar>


<!-- Sidebar for email acitons-->
 <button class="sidebar-toggle-btn" (click)="toggleEmailSidebar()">
    <i class="pi pi-envelope"></i>
 </button>


<p-sidebar [(visible)]="email_sidebar_visible" [modal]="false" position="left" [style]="{'width': 'max-content'}">
    <app-email-sidebar></app-email-sidebar>
</p-sidebar>

<div *ngIf="(currentUser$ | async) != null" class="min-h-screen flex flex-column surface-ground">
    <p-menubar [model]="topMenuItems" class="surface-overlay py-3 px-6">
        <ng-template pTemplate="start">
            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                <li>
                    <img src="../assets/images/harlowe_logo_rgb_full_color.png" alt="Image" height="40" class="mr-0 lg:mr-6">
                </li>
            </ul>
           
        </ng-template>
        <ng-template pTemplate="end">
            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                <li>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText [(ngModel)]="topMenuSearchValue" />
                    </span>
                </li>
                <li>
                    <a pRipple (click)="op.show($event)" class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150">
                        <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" pBadge [value]="unreadCount" severity="info" [badgeDisabled]="unreadCount === 0"></i>
                        <p-overlayPanel #op (onShow)="handleOverlayShow()" [dismissable]="true" [showCloseIcon]="true">
                            <app-message-list></app-message-list>
                        </p-overlayPanel>
                        <span class="block lg:hidden font-medium">Notifications</span>
                    </a>
                </li>

                <li class="border-top-1 surface-border lg:border-top-none">
                    
                    <a pRipple class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150" (click)="menu.toggle($event)" >

                        <ng-container *ngIf="( currentUser$ | async ) as currentUser" >
                            <p-avatar [image]="'data:' + currentUser?.profilePhoto?.contentType + ';base64,' + currentUser?.profilePhoto?.photo" 
                                shape="circle" class="mr-3; lg:mr-0" ></p-avatar>
                            <div class="block lg:hidden">
                                <div class="text-900 font-medium">{{currentUser.firstName}}</div>
                                <span class="text-600 font-medium text-sm">{{currentUser.lastName}}</span>
                            </div>
                        </ng-container>

                    </a>
                    
                    <p-menu  #menu [model]="avatarItems" [popup]="true"></p-menu>

                </li>
            </ul>
        </ng-template>
    </p-menubar>

    <div class="p-5 flex flex-auto">
        
        <div class="flex p-2 border-2 border-dashed surface-border border-round surface-section w-full">
            <router-outlet></router-outlet>
        </div>
    </div>

    


</div>